<div class="db-one-week-free-demo__option {{activeTab}}" [ngClass]="{'agency': isAgency}">
  <div>
    <div class="db-one-week-free-demo__option-header">
      <h1 *ngIf="title">{{ title }}</h1>
      <p *ngIf="description && !isEcommerceWebsite">{{ description }}</p>
    </div>
    <div class="db-one-week-free-demo__option-price mt20">
      <h1>
             <span *ngIf="applyCouponForPlatform" class="db-lined">
        ${{
                 (subscription?.plan?.planPrice / periodSwitchValue) | DbNumberFormatPipe:
                   periodSwitchValue === 12 || applyCouponForPlatform ? 'ceil' : 'floor'
               }}
      </span>
        ${{
          (subscription?.plan?.planPrice / periodSwitchValue * (100 - couponPercent) / 100) | DbNumberFormatPipe:
          'floor'
        }}<span>/mo</span>
      </h1>

      <p>Billed
        {{ periodSwitchValue === 12 ? 'annually' : 'monthly' }}</p>

<!--      <div class="db-billed-annual with-offer"
           *ngIf="applyCouponForPlatform"><span class="line-through">
                                        ${{ subscription?.plan?.planPrice }}</span> ${{
          (subscription?.plan?.planPrice * (100 - couponPercent) / 100) |
            DbNumberFormatPipe
        }} {{ periodSwitchValue === 12 ? 'annually' : 'monthly' }}
      </div>-->

      <a class="ds-btn-black rectangle mt15 mb22 {{isMobile ? 'ds-btn-m' : 'ds-btn-l'}}"
         (click)="onStepChange.emit('checkout')">
        <span>{{ (paidFeature ? 'Get 10Web Pro plans' : 'Try for Free') | lowerCaseSpecificWords }}</span>
      </a>
      <b class="mt27 mb16" *ngIf="planDesc">{{ planDesc }}</b>

      <div *ngIf="professionalInfo" class="db-professional-info mt7 mb8">5 hours monthly development<br/>by a <span>10Web expert</span>
      </div>

    </div>
    <div class="db-one-week-free-demo__plan-info">
      <p *ngFor="let planInfo of plan" class="mb16">

      <span class="db-icon-wrap">
        <i class="db-icon db-icon-ds-checkmark-small"></i>
      </span>
        <span class="ml8"
              [ngClass]="{'with-gradient': ['Free custom domain up to $30', '1 free custom domain up to $30'].includes(planInfo)}"
              [innerHTML]="domainName && ['Free custom domain up to $30', '1 free custom domain up to $30'].includes(planInfo) ? domainName + ' for free' : replaceParam(planInfo,
       {
          monthlyVisitors: (subscription?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
          ssdStorage: (subscription?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
          aiWebsites: subscription?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
          cdnBandwidth: (subscription?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
          websites: subscription?.plan?.services?.hosting?.domain_count?.parameter_value,
          period: periodSwitchValue === 12 ? '1 year' : '1 month'
        })">
      </span>
      </p>
    </div>
  </div>
</div>
